import { render, staticRenderFns } from "./types.vue?vue&type=template&id=71f1010b&scoped=true&"
import script from "./types.vue?vue&type=script&lang=js&"
export * from "./types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1010b",
  null
  
)

export default component.exports